import VideoCard from '../../atoms/videoCard/videoCard'
import exampleImage from '../../../assets/images/learn/sofi.png'
import SliderLearn from '../../molecules/sliderLearn/sliderLearn'
import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import video1 from '../../../assets/images/learn/videos/video-1.png'
import video2 from '../../../assets/images/learn/videos/video-2.png'
import video3 from '../../../assets/images/learn/videos/video-3.png'
import video4 from '../../../assets/images/learn/videos/video-4.png'
import video5 from '../../../assets/images/learn/videos/video-5.png'
import video6 from '../../../assets/images/learn/videos/video-6.png'
import video7 from '../../../assets/images/learn/videos/video-7.png'
import video8 from '../../../assets/images/learn/videos/video-8.png'
import video9 from '../../../assets/images/learn/videos/video-9.png'
import video10 from '../../../assets/images/learn/videos/video-10.png'
import video11 from '../../../assets/images/learn/videos/video-11.png'


import './educationalVideos.scss'

function EducationalVideos() {
  const pushDataLayer = (Label) => {
    try {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'Vive el Cole :: Videos Educativos',
        action: 'Video :: Start',
        label: Label,
        value: '',
      })
    } catch (error) {
      console.log('Datalayer error:', error)
    }
  }
  const videoCards = [
    <VideoCard
      onClick={() => pushDataLayer('Preguntas más buscadas en Google Sobre el periodo')}
      image={video1}
      title={'Preguntas más buscadas en Google Sobre el periodo'}
      text={
        'Resuelve todas tus dudas sobre el periodo con Sophi.'
      }
      url={'https://www.youtube.com/watch?v=Y9tebroZB1M&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=61&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Lo más básico que debes saber sobre el período menstrual')}
      image={video2}
      title={'Lo más básico que debes saber sobre el período menstrual'}
      text={
        '¿Menstruación? ¿Ciclo menstrual? ¿Período? ¡¡No te preocupes!! En este video te contamos lo básico que tienes que saber sobre este tema ¡Con esto serás toda una experta!'
      }
      url={'https://www.youtube.com/watch?v=FE7yNGWiQSw&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=42&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Cosas que no sabías de la menstruación')}
      image={video3}
      title={'Cosas que no sabías de la menstruación'}
      text={
        '¡¡Apostamos que no sabías esto sobre la menstruación!!'
      }
      url={'https://www.youtube.com/watch?v=vlF6K6f-Ouo&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=37&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('¿Cómo hacerte el autoexamen de seno?')}
      image={video4}
      title={'¿Cómo hacerte el autoexamen de seno?'}
      text={
        'Aprende con Sophi by Nosotras cómo hacerte el autoexamen para prevenir cualquier enfermedad y por qué es importante que lo hagas.'
      }
      url={'https://www.youtube.com/watch?v=BEDeoUslOdQ&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=36&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Errores que cometi en la pubertad')}
      image={video5}
      title={'Errores que cometi en la pubertad'}
      text={
        '¿Alguno de estos errores se te hace familiar? ¡Claro! Es súper normal que caigamos en alguno de ellos ¡Pero no te preocupes! En este video te contamos qué hacer para evitarlos.'
      }
      url={'https://www.youtube.com/watch?v=_UdoET94Iqk&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=32&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Por qué debemos usar Jabones Íntimos Nosotras')}
      image={video6}
      title={'Por qué debemos usar Jabones Íntimos Nosotras'}
      text={
        '¡Sabías que el pH de tu vagina es ácido y los jabones en barra tienen un pH diferente! Cuida de tu Zona V usando diariamente Jabones Íntimos Nosotras...'
      }
      url={'https://www.youtube.com/watch?v=sOFe2ECFX40&list=PL3dhgCQqz2gzhNI_8FUm_I52RnhXmZpnD&index=7&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Preguntas sobre la menstruación 1')}
      image={video7}
      title={'Preguntas sobre la menstruación 1'}
      text={
        'Sophi responderá algunas preguntas que nos enviaron a través de Facebook e Instagram sobre la menstruación.'
      }
      url={'https://www.youtube.com/watch?v=A4_raJ9unpM&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=15&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('Preguntas sobre la menstruación 2')}
      image={video8}
      title={'Preguntas sobre la menstruación 2'}
      text={
        'En estos dos videos, con Sophi by Nosotras, quisimos responder todas las dudas que tenían sobre la menstruació'
      }
      url={'https://www.youtube.com/watch?v=JE-oL977lJ8&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=14&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('¿Qué es el bullying? ¡Aprende con Nosotras cómo enfrentarlo!')}
      image={video9}
      title={'¿Qué es el bullying? ¡Aprende con Nosotras cómo enfrentarlo!'}
      text={
        'El acoso escolar y el bullying van mucho más allá de lo que crees. No te quedes en silencio y llénate de loving para enfrentarlo'
      }
      url={'https://www.youtube.com/watch?v=yId0Wrl6hqU&ab_channel=Nosotras'}
    />,


    <VideoCard
      onClick={() => pushDataLayer('¿Cómo es la pubertad en los hombres?')}
      image={video10}
      title={'¿Cómo es la pubertad en los hombres?'}
      text={
        '¿Te has preguntado alguna vez, cómo es la pubertad para los hombres?'
      }
      url={'https://www.youtube.com/watch?v=Y5Kh8R8XjvU&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=28&ab_channel=Nosotras'}
    />,

    <VideoCard
      onClick={() => pushDataLayer('¡Todo sobre el flujo vaginal!')}
      image={video11}
      title={'¡Todo sobre el flujo vaginal!'}
      text={
        'El flujo vaginal genera muchas preguntas en Nosotras, por eso es el invitado especial de este video.'
      }
      url={'https://www.youtube.com/watch?v=USg8JWc-EeM&list=PL3dhgCQqz2gyZzlHJFJ2-w55th-j4WjH2&index=10&ab_channel=Nosotras'}
    />,
  ]
  return (
    <div className='educational-videos'>
      <div className='educational-videos__wrapper'>
        <div className='educational-videos__title'>
          <h2>Videos educativos</h2>
        </div>
        <div className='educational-videos__slider'>
          <SliderLearn elements={videoCards} />
        </div>
      </div>
    </div>
  )
}

export default EducationalVideos
